module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("heading"), _c('AppCardLayout', {
    attrs: {
      "sidebarPosition": _vm.sidebarPosition,
      "isNoSlider": !_vm.$slots.slider
    }
  }, [_vm._t("formPlace", null, {
    "slot": "formPlace"
  }), (_vm.$slots.slider) ? _c('AppCardSliderLayout', [_vm._t("slider")], 2) : _vm._e(), (_vm.$slots.sidebar) ? _c('AppCardSidebarLayout', [_vm._t("button", null, {
    "slot": "button"
  }), _vm._t("sidebar")], 2) : _vm._e(), (_vm.$slots.main) ? _c('AppCardMainLayout', [_vm._t("main")], 2) : _vm._e()], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38ab9e1e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/layouts/cardlayouts/CardTotalLayout/AppCardTotalLayout.vue
// module id = 1c291785fccbe026eae4
// module chunks = 89